<template>
    <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary"
                class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
        <div class="mt-6 flex items-center justify-between px-6">
            <h4>{{ Object.entries(this.data).length === 0 ? "Send new ticket" : "Send reply" }}</h4>
            <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
        </div>
        <vs-divider class="mb-0"></vs-divider>

        <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings">

            <div class="p-6">

                <!-- NAME -->
                <vs-input label="Title" v-model="model.title" class="mt-5 w-full" name="item-name"
                          v-validate="'required'"/>
                <span class="text-danger text-sm"
                      v-show="errors.has('item-name')">{{ errors.first('item-name') }}</span>

                <!-- CATEGORY -->
                <vs-select v-model="model.type" label="Refer to" class="mt-5 w-full" name="item-category"
                           v-validate="'required'">
                    <vs-select-item :key="item.value" :value="item.value" :text="item.text"
                                    v-for="item in category_choices"/>
                </vs-select>
                <span class="text-danger text-sm" v-show="errors.has('item-category')">{{ errors.first('item-category') }}</span>


                <!-- NAME -->
                <vs-textarea label="Tell us about your problem" v-model="model.body" class="mt-5 w-full" name="item-body"
                             v-validate="'required'"/>
                <span class="text-danger text-sm"
                      v-show="errors.has('item-body')">{{ errors.first('item-body') }}</span>


                <span>Add file</span>
                <vs-upload multiple automatic text="Please select your file"
                           :action="home('customer/ticket/upload')"
                           :headers="headers"
                           fileName="file"
                           show-upload-button
                           :data="{to:'ticket'}"
                           @on-success="successUpload"
                />


                <!-- Product Image -->
                <template v-if="dataImg">
                    <!-- Image upload Buttons -->
                    <div class="mt-5 p-5">
                        {{dataFileName}}
                    </div>
                    <div class="modify-img flex justify-between">

                        <input type="file" class="hidden" ref="updateImgInput" @change="updateCurrImg">
                        <vs-button class="mr-4" type="flat" @click="$refs.updateImgInput.click()">New file</vs-button>
                        <vs-button type="flat" color="#999" @click="dataImg = null">Delete file</vs-button>
                    </div>
                </template>

            </div>
        </VuePerfectScrollbar>

        <div class="flex flex-wrap items-center p-6" slot="footer">
            <vs-button class="ltr:mr-6 rtl:ml-6" @click="submitData" :disabled="!isFormValid">Save</vs-button>
            <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancel</vs-button>
        </div>
    </vs-sidebar>
</template>

<script>
    import VuePerfectScrollbar from 'vue-perfect-scrollbar'
    import themeConfig from '@/../themeConfig.js'

    export default {
        props: {
            isSidebarActive: {
                type: Boolean,
                required: true
            },
            data: {
                type: Object,
                default: () => {
                },
            }
        },
        watch: {
            isSidebarActive(val) {
                if (!val) return
                if (Object.entries(this.data).length === 0) {
                    this.initValues()
                    this.$validator.reset()
                } else {
                    let {parent} = JSON.parse(JSON.stringify(this.data))
                    this.model.parent = parent;
                }
                // Object.entries(this.data).length === 0 ? this.initValues() : { this.dataId, this.dataName, this.dataCategory, this.dataOrder_status, this.dataPrice } = JSON.parse(JSON.stringify(this.data))
            }
        },
        data() {
            return {

                dataId: null,
                dataName: "",
                dataCategory: null,
                dataImg: null,
                dataOrder_status: "pending",
                dataPrice: 0,
                headers: {
                    'Authorization': 'Bearer ' + localStorage.getItem("accessToken") || localStorage.accessToken
                },
                model: {},
                category_choices: [
                    {text: 'Technical', value: 1},
                    {text: 'Financial', value: 2},
                    {text: 'Shipping', value: 3},
                    {text: 'Management', value: 4}
                ],
                settings: { // perfectscrollbar settings
                    maxScrollbarLength: 60,
                    wheelSpeed: .60,
                },
            }
        },
        computed: {
            isSidebarActiveLocal: {
                get() {
                    return this.isSidebarActive
                },
                set(val) {
                    if (!val) {
                        this.$emit('closeSidebar')
                        // this.$validator.reset()
                        // this.initValues()
                    }
                }
            },
            isFormValid() {
                return !this.errors.any()
            }
        },
        methods: {
            initValues() {
                if (this.data.id) return
                this.model = {};
            },
            home(url) {
                return themeConfig.home(url);
            },
            successUpload(up) {
                if (!this.model.files) {
                    this.model.files = [];
                }
                if (up.currentTarget.status == 200) {
                    var $dt = JSON.parse(up.currentTarget.response);
                    this.model.files.push($dt.storage);
                }
            },
            submitData() {
                this.$validator.validateAll().then(result => {
                    if (result) {
                        console.log('this.model' , this.model);
                        this.$store.dispatch("ticket/add", this.model).catch(err => {
                            console.error(err)
                        }).then(() => {
                            this.initValues();
                            this.$vs.notify({
                                text: 'Your ticket was sent successfully',
                                color: 'primary',
                            })

                        });
                        this.$emit('closeSidebar');
                    }
                })
            },
            updateCurrImg(input) {
                if (input.target.files && input.target.files[0]) {
                    var reader = new FileReader()
                    reader.onload = e => {
                        this.model.file = e.target.result;
                        this.dataFileName = input.target.files[0].name
                    }
                    reader.readAsDataURL(input.target.files[0])
                }
            }
        },
        components: {
            VuePerfectScrollbar,
        }
    }
</script>

<style lang="scss" scoped>
    .add-new-data-sidebar {
        ::v-deep .vs-sidebar--background {
            z-index: 52010;
        }

        ::v-deep .vs-sidebar {
            z-index: 52010;
            width: 600px;
            max-width: 90vw;

            .img-upload {
                margin-top: 2rem;

                .con-img-upload {
                    padding: 0;
                }

                .con-input-upload {
                    width: 100%;
                    margin: 0;
                }
            }
        }
    }

    .scroll-area--data-list-add-new {
        height: calc(100% - 4.3rem);
    }
</style>
